import { useState, useEffect } from "react";
import { Play, Star, Menu, X, Heart, Video, Gamepad2, Headphones } from "lucide-react";
import Navbar from './Navbar';

export default function MediocreMakersHomepage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [glowing, setGlowing] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setGlowing(prev => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden relative">
      {/* Navbar - properly implemented */}
      <Navbar currentPage="HOME" />
      
      {/* Background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-blue-900 opacity-20"></div>
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-blue-400 blur-3xl opacity-20"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full bg-blue-500 blur-3xl opacity-20"></div>
        <div className="absolute bottom-40 left-1/4 w-24 h-24 rounded-full bg-blue-300 blur-3xl opacity-10"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 pt-20"> {/* Added padding top to account for fixed navbar */}
        {/* Header - removed since we have the navbar */}
        
        {/* Mobile menu - keeping for now as secondary menu */}
        {/* {menuOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col justify-center items-center">
            <button 
              onClick={() => setMenuOpen(false)} 
              className="absolute top-6 right-6 text-cyan-400 hover:text-cyan-300 transition-colors"
            >
              <X size={24} />
            </button>
            <nav className="flex flex-col gap-8 text-2xl text-center">
              <a href="#" className="text-cyan-400 hover:text-cyan-300 transition-colors">Home</a>
              <a href="#" className="text-white hover:text-cyan-300 transition-colors">Games</a>
              <a href="#" className="text-white hover:text-cyan-300 transition-colors">About</a>
            </nav>
          </div>
        )}*/}

        {/* Hero section */}
        <section className="flex flex-col items-center justify-center text-center px-6 pt-10 pb-16">
          <div className={`logo-container mb-8 ${glowing ? 'animate-pulse' : ''}`}>
            <div className="w-64 h-64 mx-auto relative">
              <div className="absolute inset-0 bg-cyan-400 opacity-20 rounded-full blur-lg"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="border-2 border-cyan-400 w-56 h-40 relative">
                  {/* Top diamond point */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rotate-45 border-2 border-cyan-400 bg-black"></div>
                  {/* Bottom diamond point */}
                  <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rotate-45 border-2 border-cyan-400 bg-black"></div>
                  
                  {/* Small circles */}
                  <div className="absolute -left-2 top-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -right-2 top-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -left-2 bottom-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -right-2 bottom-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  
                  {/* Text */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-2">
                    <div className="text-cyan-400 text-4xl font-bold tracking-wider leading-none">
                      <div>THE</div>
                      <div>MEDIOCRE</div>
                      <div>MAKERS</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold mb-4 text-white">
            Perfectly <span className="text-cyan-400">Imperfect</span> Creations
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mb-8">
            Gaming adventures, creative projects, and entertaining content that celebrates the joy in being mediocre.
          </p>
        </section>

         {/* 
        <section className="py-16 px-6 bg-blue-900 bg-opacity-20">
          <h2 className="text-3xl font-bold mb-12 text-center">Our <span className="text-cyan-400">Mediocre</span> Content</h2>
          
        </section>

        
        <section className="py-16 px-6">
          <h2 className="text-3xl font-bold mb-12 text-center">Featured <span className="text-cyan-400">Content</span></h2>
          
        </section>*/}

        {/* Footer */}
        <footer className="bg-black py-12 px-6">
          <div className="max-w-6xl mx-auto">
            <div className={`mb-8 ${glowing ? 'animate-pulse' : ''}`}>
              <div className="text-cyan-400 text-lg font-bold tracking-wider">THE MEDIOCRE MAKERS</div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              <div>
                <h3 className="text-lg font-bold mb-4">Navigate</h3>
                <ul className="space-y-2">
                  <li><a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Home</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-bold mb-4">Social</h3>
                <ul className="space-y-2">
                  <li><a href="https://x.com/MediocreMakers" className="text-gray-400 hover:text-cyan-400 transition-colors">Twitter</a></li>
                </ul>
                <ul className="space-y-2">
                  <li><a href="https://www.youtube.com/@TheMediocreMakers/featured" className="text-gray-400 hover:text-cyan-400 transition-colors">Youtube</a></li>
                </ul>
                <ul className="space-y-2">
                  <li><a href="https://www.instagram.com/TheMediocreMakers" className="text-gray-400 hover:text-cyan-400 transition-colors">Instagram</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-bold mb-4">Support</h3>
                <ul className="space-y-2">
                  <li><a href="https://ko-fi.com/themediocremakers" className="text-gray-400 hover:text-cyan-400 transition-colors">Ko-Fi</a></li>
                </ul>
                <ul className="space-y-2">
                  <li><a href="https://gamejolt.com/@TheMediocreMakers" className="text-gray-400 hover:text-cyan-400 transition-colors">Gamejolt</a></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} The Mediocre Makers & 4FingerStudios. 
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}